module.exports = __webpack_public_path__ + "img/1.ec2f8776.png";